// 模板 17：创投机构与产业基金官网

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner_1.jpg'),
        path: '',
        title: '专注科技与产业升级的投资机构',
        content:
          '深度布局科技创新与产业升级领域，为企业提供长期资本与资源支持。'
      },
      {
        img: require('@/assets/img/banner2.jpg'),
        path: '',
        title: '与优秀创业者同行',
        content:
          '不仅提供资金，更提供战略、资源与成长陪伴。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '投资组合与项目管理平台',
      subtitle: '/ Portfolio Management',
      paragraphs: [
        '围绕项目来源、投后管理与退出等环节，搭建一体化管理平台。',
        '帮助投资团队更高效地管理项目与投资组合表现。'
      ],
      buttonText: '了解投资方向'
    },
    contact: {
      title: '寻找下一位长期合作伙伴',
      subTitle: '欢迎优秀创业团队与合作伙伴联系',
      buttonText: '对接投资团队'
    },
    customers: [],
    advantages: []
  },
  company: {
    name: '启原资本管理有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__是一家专注科技创新与产业升级的股权投资机构，关注企业长期价值与稳健增长。',
      '团队成员具有产业与投资复合背景，致力于与创业者共同构建更有韧性的企业。'
    ]
  },
  news: [
    {
      id: 'VC01',
      title: '完成新一期基金募集',
      introduce:
        '新一期基金将重点关注产业数字化与智能制造方向的投资机会。',
      date: '12-01',
      year: '2024'
    },
    {
      id: 'VC02',
      title: '多家被投企业入选行业榜单',
      introduce:
        '包括智能制造、云服务与医疗科技等多个领域的优秀企业。',
      date: '08-17',
      year: '2024'
    },
    {
      id: 'VC03',
      title: '举办产业创新闭门研讨会',
      introduce:
        '邀请行业专家与被投企业代表共同探讨产业升级趋势。',
      date: '04-09',
      year: '2024'
    },
    {
      id: 'VC04',
      title: '发布年度投资观察报告',
      introduce:
        '从资本与产业两个角度分析细分赛道机会与挑战。',
      date: '10-26',
      year: '2023'
    },
    {
      id: 'VC05',
      title: '多支基金完成优秀退出案例',
      introduce:
        '通过上市与并购等方式，实现多支基金优质退出。'
      ,
      date: '06-13',
      year: '2023'
    }
  ],
  software: {
    smartTown: {
      title: '项目与投资管理系统',
      sections: [
        {
          heading: '1. 项目线索管理',
          content:
            '记录项目来源、跟进记录与内部评审意见。'
        },
        {
          heading: '2. 投资流程管理',
          content:
            '从立项、尽调到投决全流程在线记录与协同。'
        },
        {
          heading: '3. 投后事项管理',
          content:
            '跟踪企业经营关键指标与投后服务事项。'
        },
        {
          heading: '4. 退出与回报管理',
          content:
            '记录退出路径与回报情况，便于整体业绩分析。'
        }
      ]
    },
    bigData: {
      title: '投资组合分析平台',
      sections: [
        {
          heading: '1. 项目分布视图',
          desc:
            '按行业、阶段与地域等维度统计项目分布。'
        },
        {
          heading: '2. 组合表现分析',
          desc:
            '按基金与时间维度分析组合估值与回报变化。'
        },
        {
          heading: '3. 风险预警',
          desc:
            '识别业绩下滑与关键指标异常的项目，便于提前干预。'
        },
        {
          heading: '4. 报告与对外披露',
          desc:
            '为 LP 报告与监管披露提供数据基础。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '股权投资',
      engTitle: 'Equity Investment',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: '产业协同',
      engTitle: 'Industry Synergy',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '投后赋能',
      engTitle: 'Post-investment Support',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '资本市场服务',
      engTitle: 'Capital Market Service',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '投资分析师',
    responsibilities: [
      '协助进行行业研究与项目筛选；',
      '参与尽调与估值工作，撰写投资分析报告；',
      '跟踪被投企业经营情况，协助投后管理。'
    ],
    requirements: [
      '具备金融、经济或相关专业背景，对科技与产业升级有兴趣；',
      '具备良好的分析能力与逻辑思维；',
      '具备良好的沟通与团队协作能力。'
    ],
    buttonText: '投递简历'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-17.js